
// municipioService.js
import api from './api';

export const municipioService = {
    obtenerPorDepartamento: (idDepartamento) =>
        api.get(`/get/obtener_municipios.php?id_departamento=${idDepartamento}`)
            .then(response => ({
                data: Array.isArray(response.data) ? response.data : response.data?.data || []
            }))
};
